/**
 * 触发原生的按键事件
 * @param el DOM
 * @param evtType 事件类型，如：click
 * @param keyCode 键值
 */
export default (el, evtType, keyCode) => {
  let doc = el.ownerDocument
  let win = doc.defaultView || doc.parentWindow
  let evtObj
  if (doc.createEvent) {
    if (win.KeyEvent) {
      evtObj = doc.createEvent('KeyEvents')
      evtObj.initKeyEvent(evtType, true, true, win, false, false, false, false, keyCode, 0)
    } else {
      evtObj = doc.createEvent('UIEvents')
      Object.defineProperty(evtObj, 'keyCode', {
        get: function () {
          return this.keyCodeVal
        }
      })
      Object.defineProperty(evtObj, 'which', {
        get: function () {
          return this.keyCodeVal
        }
      })
      evtObj.initUIEvent(evtType, true, true, win, 1)
      evtObj.keyCodeVal = keyCode
      if (evtObj.keyCode !== keyCode) {
        console.log('keyCode ' + evtObj.keyCode + ' 和 (' + evtObj.which + ') 不匹配')
      }
    }
    el.dispatchEvent(evtObj)
  } else if (doc.createEventObject) {
    evtObj = doc.createEventObject()
    evtObj.keyCode = keyCode
    el.fireEvent('on' + evtType, evtObj)
  }
}



// WEBPACK FOOTER //
// ./src/packages/utils/src/fireKeyEvent.js